module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/product-img.44eb866e.svg";